import { Space } from "antd";
import CommonButton from "commons/Buttons/CommonButton";
import ConfirmButton from "commons/Buttons/ConfirmButton";
import CommonTable from "commons/CommonTable";
import CommonCard from "commons/Layout/CommonCard";
import { openNotification } from "commons/Notifications";
import "ol/ol.css";
import { useMemo, useRef } from "react";
import ServiceUser from "services/user";

const Users = () => {
    const UserTable = useRef<any>();

    const columns = useMemo(
        () => [
            {
                title: 'Id',
                dataIndex: 'id',
                key: 'id',
                width: 50,
            },
            {
                title: 'Username',
                dataIndex: 'username',
                key: 'username',
                search: true,
            },
            {
                title: 'Email',
                dataIndex: 'email',
                key: 'email',
            },
            {
                title: 'Stato',
                dataIndex: 'status',
                key: 'status',
                render: (status) => {
                    return status === 10 ? 'Attivo' : 'Disabilitato'
                }
            },
            {
                title: 'Nome',
                dataIndex: 'person.name',
                search: true,
            },
            {
                title: 'Cognome',
                dataIndex: 'person.surname',
                search: true,
            },
            // {
            //     title: 'Ruolo',
            //     key: 'roles',
            //     className: 'hideSort',
            //     //render: (user) =>
            //     // getUserMainRoles(user).map(({ organization, roles }) => (
            //     //     <div key={organization}>
            //     //         <strong>{organization}</strong>: {roles.join(', ')}
            //     //     </div>
            //     // )),
            // },
            {
                title: 'Azioni',
                key: 'action',
                className: 'actions',
                render: (text, record) => (
                    <div className="text-center">
                        <Space>
                            <ConfirmButton
                                onClick={() => changeStatusUser(record)}
                                confirmMessage={record?.status === 10 ? "Vuoi bloccare l'utente selezionato?" : "Vuoi attivare l'utente selezionato?"}
                                type="primary"
                                danger={record?.status === 10 ? true : false}
                            >
                                {record?.status === 10 ? 'Blocca utente' : 'Attiva utente'}
                            </ConfirmButton>
                        </Space>
                    </div>
                ),
            },
        ],
        []
    );

    const changeStatusUser = (record) => {
        let status = record?.status === 10 ? 9 : 10;
        ServiceUser.update({ data: { status: status }, id: record?.id })
            .then(async (response) => {
                openNotification({
                    message: 'OK',
                    description: 'Utente aggiornato correttamente',
                    type: 'success',
                });
                UserTable?.current?.refresh()
            });
    };

    return (
        <>
            <CommonCard
                title="Lista Utenti"
                className="mt-3"
            >
                <CommonTable
                    columns={columns}
                    sortAllColumns={true}
                    // data={userList}
                    service={(paginationParams, filters) => ServiceUser.list(paginationParams, filters)}
                    //loading={loading}
                    pageSize={10}
                    ref={UserTable}
                />

            </CommonCard>

        </>
    );
};

export default Users;
